import {isValid, parse} from "date-fns";
import {formatInTimeZone} from "date-fns-tz";

/**
 * @hidden
 */
export function toIsoTimeString(dateOrTime: Date | string, zone: string): string;

/**
 * @hidden
 */
export function toIsoTimeString(dateOrTime: undefined, zone: string): undefined;

/**
 * @hidden
 */
export function toIsoTimeString(dateOrTime: null, zone: string): null;

/**
 * @hidden
 */
export function toIsoTimeString(dateOrTime: Date | string | undefined, zone: string): string | undefined;

/**
 * @hidden
 */
export function toIsoTimeString(dateOrTime: Date | string | null, zone: string): string | null;

export function toIsoTimeString(dateOrTime: Date | string | undefined | null, zone: string): string | undefined | null;

/**
 * Returns a valid iso time string (hh:mm) to represent the time in the specified zone. For example, it will return
 * '00:00' if it is midnight in the specified timezone
 *
 * If dateOrTime is a string, it is validated that it is a valid iso time string (hh:mm)
 *
 * If date is a Date, then it is taken as a date time in UTC and converted to an iso time string in the specified zone.
 *
 * @param dateOrTime
 * @param zone the time zone descriptor, usually an offset or IANA time zone name (e.g. America/Los_Angeles)
 */
export function toIsoTimeString(dateOrTime: Date | string | undefined | null, zone: string): string | undefined | null {
  if (typeof dateOrTime === 'undefined') {
    return undefined;
  } else if (dateOrTime === null) {
    return null;
  } else if (typeof dateOrTime === 'string') {
    if (! /^[0-9]{1,2}:[0-9]{2}:[0-9]{2}$/.test(dateOrTime)) {
      throw new Error(`'${dateOrTime}' is not a valid ISO date (hh:mm)`);
    }
    // const zoned = utcToZonedTime(toDate(date, { timeZone: zone }), zone);
    if (! isValid(parse(dateOrTime, 'HH:mm:ss', new Date()))) {
      throw new Error(`'${dateOrTime}' is not a valid ISO date (hh:mm)`);
    }
    return dateOrTime;
  } else {
    // date instanceof Date is true
    return formatInTimeZone(dateOrTime, zone, 'HH:mm:ss');
  }
}
